module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAcklEQVRIS+2Vuw2AQAxD7R5mpWYCamaF3oiCrzjFqcmVkePiXWRT0ghgADCTnPDxHM19jZIWAB2AlWTfMA01b1MdA5JsmIaaMj0J7B8V8nI0xfTPTB/54JyLqbnywVzI3XKZ5ng5mVtMw1JLl6NTv1nNBsTO+sW0vM1BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play_combination_Icon.png
// module id = zH9x
// module chunks = 0